export enum IndividualGender {
  female = 0,
  male = 1,
  unknown = 2,
}